const LAST_ACTIVITY_KEY = 'tars_last_activity';

// Mirrors the backend SessionService timeout (routes.py: session_timeout_minutes=30) —
// once the backend has forgotten the conversation, the frontend shouldn't keep showing it.
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

export const isSessionExpired = (): boolean => {
  const last = localStorage.getItem(LAST_ACTIVITY_KEY);
  if (!last) return false;
  return Date.now() - Number(last) > SESSION_TIMEOUT_MS;
};

export const touchActivity = (): void => {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
};
